import { Grid } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";
import WSMobViewDataGrid from "../../../Components/DataGrid/WSMobViewDataGrid";
import { IRows } from "../../../Components/Filter/WSFilterComponent";
import { IRoleMain, IsSmallScreen, MasterPages } from "../../../commonFunctions/CommonFunctions";
import { Header } from "../../Header/Header";
import { getPermissions } from "../../../commonFunctions/PermissionManger";
import PermissionDenied from "../../../commonFunctions/PermissionDenied";
import { useDispatch } from "react-redux";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import { resetDataComponent } from "../../../StateManagement/actions";
import ConfirmationPopup from "../../../Components/Confirmation/Confirmation";

export const AnnouncementList: React.FC<any> = React.memo(
    (props) => {
        const navigate = useNavigate();
        const { view, exports, add, edit,del } = getPermissions(MasterPages.Meetings, IRoleMain.Masters);
        const source = {
            url: "announcement/search",
            page: 1,
            pageSize: 10,
            filter: [],
            sort: [],
        };
        const [isPopupOpen, setPopupOpen] = useState(false);
        const [selectedId, setSelectedId] = useState<number | null>(null);
        const dispatch = useDispatch();
        const { showMessage } = useSnackbar();
        /**
         * Edit function
         * @param action 
         * @param row 
         */
        const handleAction = (action: string, row: any) => {
            if (action === "Edit") {
                navigate(`/announcement/edit/${row?.id}`)
            } else if (action === 'Delete') {
                setSelectedId(row.id); // Set the ID of the row to be deleted
                setPopupOpen(true)
            }
        };

        const columns: IColumns[] = [
            {
                header: "Title",
                fieldName: "title",
                tooltip: true,
                type: 'default',
            },
            {
                header: "Start Date",
                fieldName: "date",
                type: 'date'
            },
            {
                header: "End Date",
                fieldName: "date",
                type: 'date'
            },
            {
                header: "Description",
                fieldName: "description",
                tooltip: true,
                type: 'default',
            },
            {
                header: "Actions",
                fieldName: "actions",
                type: "action",
                actions: [edit ? "Edit" : undefined, del ? 'Delete' : undefined],
                actionCallback: (action, row) => handleAction(action, row),
            },
        ];
        const filterRows: IRows[] = [
            {
                label: "Title",
                fieldName: "Title",
                type: "text",
                operator: 'like'
            },

        ];
        const transFormData = (data: any) => {
            data && data?.map((item: any) => {
                item.name = item?.firstName + item?.lastName
            })
            return data
        }
        const handleClick = () => {
            navigate('/announcement/add')
        }
        const handleDelete = (response: any) => {
            dispatch(resetDataComponent('announcement-list'));
            showMessage(response?.message, response?.success ? 'success' : 'error')
        };
        return (
            <><Header title="Announcement" type="simple" isDivider={true} />
                {view ? <Grid container spacing={2}>
                    {!IsSmallScreen() ? <Grid item xs={12}>
                        <WSDataGrid
                            transFormData={transFormData}
                            id="announcement-list"
                            title="Announcements"
                            filterFields={filterRows}
                            columns={columns}
                            source={source}
                            exportCsv={exports}
                            addButton={add ? { label: '', color: 'secondary' } : undefined}
                            onAddButtonClick={handleClick}
                        />
                    </Grid> : <Grid item xs={12}>
                        <WSMobViewDataGrid
                            transFormData={transFormData}
                            id="announcement-list"
                            title="Announcements"
                            filterFields={filterRows}
                            columns={columns}
                            source={source}
                            exportCsv={exports}
                            addButton={add ? { label: '', color: 'secondary' } : undefined}
                            onAddButtonClick={handleClick}
                        />
                    </Grid>}
                </Grid> : <PermissionDenied />}
                {selectedId !== null && <ConfirmationPopup
                    apiUrl={'announcement'}
                    id={selectedId}
                    confirmMessage="Are you sure you want to delete this item?"
                    open={isPopupOpen}
                    onClose={() => setPopupOpen(false)}
                    onConfirm={handleDelete}
                />}
            </>
        );
    }
);




